import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons'

import { AlertBanner, AlertContent, AlertText } from './styled'

interface FormInfoAlertProps {
  children: React.ReactNode
  className?: string
}

export const FormInfoAlert: React.FC<FormInfoAlertProps> = ({
  children,
  className,
}) => (
  <AlertBanner className={className}>
    <FontAwesomeIcon icon={faInfoCircle} aria-hidden />
    <AlertContent>
      <AlertText>{children}</AlertText>
    </AlertContent>
  </AlertBanner>
)

export { AlertEmphasis, AlertStrong, GuideLink } from './styled'

export default FormInfoAlert
